<template>
    <div>
        <template v-if="loading">
            <loading-spinner/>
        </template>

        <x-container v-else fluid app-width>
            <x-layout align-end mb-5>
                <x-flex xs8>
                    <h1>Obligors</h1>
                </x-flex>

                <x-flex xs4 text-xs-right mb-2>
                    <x-dialog v-model="dialog" persistent max-width="600px">
                        <template v-slot:activator="{ on }">
                            <x-btn color="primary" large class="ma-0" v-on="on">New Obligor</x-btn>
                        </template>

                        <x-form ref="newObligorForm">
                            <x-container fluid grid-list-lg>
                                <x-layout>
                                    <x-flex xs12>
                                        <h2>New obligor</h2>
                                    </x-flex>
                                </x-layout>

                                <x-layout wrap>
                                    <x-flex xs12>
                                        <x-text-field
                                            v-model="newObligor.name"
                                            label="Name"
                                            placeholder=" "
                                            :rules="[v => ruleRequired(v, 'Name')]"
                                            outline
                                        />
                                    </x-flex>
                                    <x-flex xs12>
                                        <x-autocomplete
                                            v-model="newObligor.country_id"
                                            :items="countries"
                                            label="Country"
                                            placeholder="Country"
                                            item-value="id"
                                            item-text="name"
                                            :rules="[v => ruleRequired(v, 'Country')]"
                                            append-icon="keyboard_arrow_down"
                                            outline
                                        />
                                    </x-flex>
                                    <x-flex xs12>
                                        <x-text-field
                                            v-model="newObligor.address.line1"
                                            label="Address"
                                            placeholder=" "
                                            outline
                                        />
                                    </x-flex>
                                    <x-flex xs12>
                                        <x-autocomplete
                                            v-model="newObligor.is_bank"
                                            :items="isBankOptions"
                                            label="Is bank"
                                            placeholder="Is bank"
                                            :rules="[v => ruleRequired(v, 'Is bank')]"
                                            append-icon="keyboard_arrow_down"
                                            outline
                                        />
                                    </x-flex>
                                </x-layout>

                                <x-layout class="response-actions" justify-space-between>
                                    <x-flex xs6 class="text-xs-left">
                                        <x-btn
                                            class="ma-0"
                                            color="tertiary"
                                            small
                                            @click="close"
                                        >
                                            Cancel
                                        </x-btn>
                                    </x-flex>

                                    <x-flex xs6 class="text-xs-right">
                                        <x-btn
                                            class="ma-0"
                                            color="primary"
                                            small
                                            @click="save"
                                        >
                                            Save
                                        </x-btn>
                                    </x-flex>
                                </x-layout>
                            </x-container>
                        </x-form>
                    </x-dialog>
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex>
                    <x-container class="summary-container">
                        <x-layout class="mb-4">
                            <x-flex xs6>
                                <x-autocomplete
                                    v-model="filterCountry"
                                    :items="this.filterCountries"
                                    label="Filter country"
                                    placeholder="Filter country"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    append-icon="keyboard_arrow_down"
                                    outline
                                    @input="handleFilterChange()"
                                />
                            </x-flex>

                            <x-flex xs6>
                                <x-text-field
                                    v-model="searchText"
                                    label="Search"
                                    placeholder="Search"
                                    @input="handleFilterChange()"
                                    outline
                                />
                            </x-flex>
                        </x-layout>

                        <x-layout mb-5>
                            <x-flex>
                                <x-data-table
                                    :headers="headers"
                                    :items="obligors"
                                    hide-actions
                                    class="fit-to-width no-row-hover w-100"
                                    :pagination.sync="pagination"
                                    :rows-per-page-items="[10]"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>{{ props.item.name }}</td>
                                        <td>{{ props.item.country?.name }}</td>
                                        <td>{{ props.item.address?.line1 }}</td>
                                        <td>{{ props.item.is_bank | yesOrNo }}</td>
                                    </template>
                                </x-data-table>
                            </x-flex>
                        </x-layout>

                        <x-layout>
                            <x-flex text-xs-center>
                                <x-pagination
                                    v-model="pagination.current"
                                    :length="pagination.total"
                                    :total-visible="15"
                                    circle
                                    color="grey-1"
                                    @input="onPageChange"/>
                            </x-flex>
                        </x-layout>
                    </x-container>
                </x-flex>
            </x-layout>
        </x-container>
    </div>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';
    import rules from '~/mixins/rules';

    export default {
        name: "ObligorPanel",
        components: {
            Modal
        },
        mixins: [rules],
        data() {
            return {
                loading: true,
                dialog: false,
                obligors: [],
                countries: [],
                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                    },
                    {
                        text: 'Country',
                        value: 'country',
                    },
                    {
                        text: 'Address',
                        value: 'address',
                    },
                    {
                        text: 'Is bank',
                        value: 'is_bank',
                    },
                ],
                newObligor: {
                    name: '',
                    country_id: '',
                    is_bank: '',
                    address: {
                        line1: null
                    }
                },
                defaultObligor: {
                    name: '',
                    country_id: '',
                    is_bank: '',
                    address: {
                        line1: null
                    }
                },
                pagination: {
                    descending: false,
                    page: 1,
                    sortBy: 'name',
                    current: 1,
                    total: 0
                },
                isBankOptions: [
                    {
                        value: true,
                        text: 'Yes'
                    },
                    {
                        value: false,
                        text: 'No'
                    },
                ],
                searchText: '',
                filterCountry: {
                    id: -1,
                    name: 'All countries'
                },
                filterCountries: null,
                obligorRequest: null,
                axiosCancel: null
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                this.fetchObligors();

                const countryRequest = axios.get(this.$root.api(`country`)).then(response => {
                    this.countries = response.data.data;
                    this.filterCountries = [
                        {
                            id: -1,
                            name: 'All countries',
                        },
                        ...this.countries
                    ]
                });

                axios.all([this.obligorRequest, countryRequest]).then(() => {
                    this.loading = false;
                });
            },
            async handleFilterChange() {
                this.goToPage(1);
                await this.fetchObligors();
            },
            goToPage(n) {
                this.pagination = {
                    ...this.pagination,
                    page: n,
                    current: n,
                }
            },
            async fetchObligors() {
                if (this.axiosCancel) {
                    this.axiosCancel();
                }

                const self = this;

                this.obligorRequest = axios.get(this.$root.api(`broker/obligors`), {
                    params: {
                        searchText: this.searchText,
                        countryId: this.filterCountry.id,
                        page: this.pagination.current,
                        pagination: JSON.stringify(this.pagination),
                    },
                    cancelToken: new axios.CancelToken(function (c) {
                        // An executor function receives a cancel function as a parameter
                        self.axiosCancel = c;
                    })
                }).then(response => {
                    this.obligors = response.data.data;
                    this.pagination.current = response.data.current_page;
                    this.pagination.total = response.data.last_page;
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        console.log('Obligors request was cancelled');
                    }
                });
            },
            onPageChange() {
                this.fetchObligors();
            },
            close() {
                this.dialog = false;
                this.newObligor = JSON.parse(JSON.stringify(this.defaultObligor));
                this.$refs.newObligorForm.resetValidation();
            },
            async save() {
                if (this.$refs.newObligorForm.validate()) {
                    await axios.post(this.$root.api(`broker/obligors`), {
                        name: this.newObligor.name,
                        country_id: this.newObligor.country_id,
                        is_bank: this.newObligor.is_bank,
                        address: {
                            line1: this.newObligor.address.line1
                        }
                    });

                    await this.fetchObligors();
                    this.close();
                }
            },
        },
        watch: {
            pagination() {
                this.fetchObligors();
            }
        }
    }
</script>
